import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Gift, Wallet, Crown } from "@phosphor-icons/react";

import { PageShell } from "../../features/shared/layouts/PageShell";
import { SurfaceCard } from "../../features/shared/ui/surface/SurfaceCard";
import { defaultIconProps } from "../../features/shared/ui/icons";

const pageStackClasses = "flex flex-col items-center justify-center min-h-screen gap-12 py-12 text-slate-900";
const heroSectionClasses = "flex flex-col items-center text-center max-w-2xl mx-auto px-4";
const iconClasses = "flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 mb-6 text-3xl shadow-sm";
const heroTitleClasses = "text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-4";
const heroSubtitleClasses = "text-lg text-slate-600 mb-8 leading-relaxed";
const calloutClasses = "flex flex-col gap-1 rounded-2xl bg-emerald-50 border border-emerald-100 p-4 text-emerald-800 text-sm font-medium mb-8 max-w-md";
const actionsClasses = "flex flex-wrap items-center justify-center gap-4";
const gridClasses = "grid grid-cols-1 gap-6 sm:grid-cols-2 max-w-4xl w-full px-4";
const cardClasses = "h-full flex flex-col justify-between rounded-2xl border border-slate-200 bg-white p-1 shadow-sm hover:shadow-md transition-shadow";
const cardTitleClasses = "flex items-center gap-2 text-lg font-semibold text-slate-900";

const primaryButtonClasses = "pm-btn pm-btn-primary pm-btn-lg";
const ghostButtonClasses = "pm-btn pm-btn-ghost pm-btn-lg";
const cardButtonClasses = "pm-btn pm-btn-tonal w-full";

export function SignupBonusPage() {
  const { t } = useTranslation();

  return (
    <PageShell className={pageStackClasses} width="wide">
      <section className={heroSectionClasses}>
        <div className={iconClasses} aria-hidden>
          <Gift {...defaultIconProps} />
        </div>
        <h1 className={heroTitleClasses}>{t("welcome_bonus.title")}</h1>
        <p className={heroSubtitleClasses}>{t("welcome_bonus.subtitle")}</p>

        <div className={calloutClasses}>
          <p>{t("welcome_bonus.credit_callout")}</p>
          <small className="text-emerald-600 font-normal">{t("welcome_bonus.credit_hint")}</small>
        </div>

        <div className={actionsClasses}>
          <Link to="/dashboard" className={primaryButtonClasses}>
            {t("welcome_bonus.cta_dashboard")}
          </Link>
          <Link to="/billing" className={ghostButtonClasses}>
            {t("welcome_bonus.cta_billing")}
          </Link>
        </div>
      </section>

      <section className={gridClasses}>
        <SurfaceCard className={cardClasses}>
          <SurfaceCard.Header
            title={
              <span className={cardTitleClasses}>
                <Wallet {...defaultIconProps} aria-hidden />
                {t("welcome_bonus.top_up.title")}
              </span>
            }
            subtitle={t("welcome_bonus.top_up.subtitle")}
          />
          <SurfaceCard.Body>
            <p className="text-slate-600">{t("welcome_bonus.top_up.description")}</p>
          </SurfaceCard.Body>
          <SurfaceCard.Footer>
            <Link to="/billing" className={cardButtonClasses}>
              {t("welcome_bonus.top_up.cta")}
            </Link>
          </SurfaceCard.Footer>
        </SurfaceCard>

        <SurfaceCard className={cardClasses}>
          <SurfaceCard.Header
            title={
              <span className={cardTitleClasses}>
                <Crown {...defaultIconProps} aria-hidden />
                {t("welcome_bonus.subscription.title")}
              </span>
            }
            subtitle={t("welcome_bonus.subscription.subtitle")}
          />
          <SurfaceCard.Body>
            <p className="text-slate-600">{t("welcome_bonus.subscription.description")}</p>
          </SurfaceCard.Body>
          <SurfaceCard.Footer>
            <Link to="/billing" className={cardButtonClasses}>
              {t("welcome_bonus.subscription.cta")}
            </Link>
          </SurfaceCard.Footer>
        </SurfaceCard>
      </section>
    </PageShell>
  );
}
